module.exports = __webpack_public_path__ + "img/miniLogo.eef3f5f2.svg";